import { render, staticRenderFns } from "./jump-test.vue?vue&type=template&id=29542e3d&scoped=true&"
import script from "./jump-test.vue?vue&type=script&lang=js&"
export * from "./jump-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29542e3d",
  null
  
)

export default component.exports